import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../stories/Button';
import logoGif from '../../assets/PickTheSetlist_005.webp';
import './styles.css';
import '../../styles/fonts.css';

export const AuthHeader = ({ onAuthViewChange }) => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      onAuthViewChange('login'); // Redirect to login view after successful logout
    } catch (error) {
      // Handle error silently in production, log in development
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to log out:', error);
      }
    }
  };

  return (
    <header>
      <div className="header">
        <div className="header-logo-container">
          <img src={logoGif} alt="Pick The Setlist" className="header-logo-gif" />
          <h1 className="main-title visually-hidden">PICK THE SETLIST</h1>
        </div>
        <div className="header-controls">
          {user && (
            <>
              <span className="welcome">
                Welcome, <b>{user.email}</b>!
              </span>
              <Button size="small" onClick={handleLogout} label="Log out" />
            </>
          )}
        </div>
      </div>
    </header>
  );
};

AuthHeader.propTypes = {
  onAuthViewChange: PropTypes.func.isRequired,
};
